export default {
  type: 'object',
  properties: {
    name: {
      title: 'schema.exam.name',
      type: 'string',
      fieldRequired: true
    },
    unit: {
      title: 'schema.exam.unit',
      type: 'string',
      fieldRequired: true
    },
    clubId: {
      title: 'schema.exam.clubId',
      type: 'number',
      fieldRequired: false
    },
    sportId: {
      title: 'schema.exam.sportId',
      type: 'number',
      fieldRequired: false
    },
    teamId: {
      title: 'schema.exam.teamId',
      type: 'number',
      fieldRequired: false
    }
  }
};
